<template>
    <v-dialog v-model="dialog" persistent width="30%" :disabled="disabled">
        <template v-slot:activator="{ on, attrs }">
            <slot name="activator" :on="on" :attrs="attrs"></slot>
        </template>
        <v-card>
            <v-card-title class="flex-nowrap align-start">
                Are you sure you want to delete?
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" icon><v-icon>clear</v-icon></v-btn>
            </v-card-title>
            <v-card-text>Embedded videos will stop working after you delete the {{ videoCopy() }}!</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <vimeo-upload-dialog :videos="videos" crud="delete" @dismissed="dismiss">
                    <v-btn color="error" text>Delete</v-btn>
                </vimeo-upload-dialog>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
const VimeoUploadDialog = () => import('../components/VimeoUploadDialog.vue')

export default {
    name: 'VimeoConfirmDialog',
    components: {
        VimeoUploadDialog
    },
    data() {
        return {
            dialog: false
        }
    },
    props: {
        videos: { type: Array, required: true },
        disabled: { type: Boolean, default: false }
    },
    methods: {
        dismiss() {
            this.$emit('dismissed')
        },
        videoCopy() {
            return this.videos.length > 1 ? 'videos' : 'video'
        }
    }
}
</script>
